import React from "react";
import { FormContext } from "./FormContext";

export default class Select extends React.Component {
	static contextType = FormContext;

	static id = 1;

	constructor(props) {
		super(props);
		this.refSelect = React.createRef();
		this.state = {
			value: props.value || '',
			error: false
		};

		this.handleChange = this.handleChange.bind(this);
		this.setValue = this.setValue.bind(this);
		this.setError = this.setError.bind(this);
		this.htmlId = "s" + Select.id++;
	}

	setValue(value) {
		this.setState({ value: value });
		$(this.refSelect.current).val(value).trigger('change');
	}

	setError(error) {
		this.setState({ error: error });
	}

	handleChange() {
		var value;
		if (this.props.multiple) {
			let options = this.refSelect.current.options;
			value = [];
			for (let i in options) {
				if (options[i].selected) {
					if (this.props.isint && (parseInt(options[i].value) + '') == options[i].value)
						value.push(parseInt(options[i].value));
					else
						value.push(options[i].value);
				}
			}
		} else if (typeof (this.refSelect.current) != 'undefined') {
			value = this.refSelect.current.value;
			if (!this.props.required && value == '')
				value = null;
		}
		if (this.props.onChange && this.props.onChange(value) === false)
			return;
		this.setState({ value: value || '' });
		if (this.props.isint && !this.props.multiple && (parseInt(value) + '') == value)
			value = parseInt(value);
		if (this.context) this.context.setValue(this.props.name, value);
	}

	componentDidMount() {
		if (this.context) {
			let value = this.props.value;
			if (this.props.multiple)
				value = this.props.value.map(x => {
					if (this.props.isint && (parseInt(x) + '') == x)
						return parseInt(x);
					else
						return x + '';
				});
			else if (this.props.isint && (parseInt(value) + '') == value)
				value = parseInt(value);
			this.context.initInput(this.props.name, value, this.setValue, this.setError);
		}
		//if (this.props.multiple) {
		let el = $(this.refSelect.current);
		let self = this;
		let options = {
			minimumResultsForSearch: 10,
			width: '100%'
		};
		if (!this.props.required) {
			options.allowClear = true;
			options.placeholder = t.commonNotSelected;
		} else {
			options.placeholder = t.commonSelect;
		}
		if (this.props.placeholder)
			options.placeholder = this.props.placeholder;
		if (this.props.sortAZ)
			options.sorter = data => data.sort((a, b) => a.text.localeCompare(b.text));
		if (this.props.multiple)
			options.closeOnSelect = false;
		let parent = el.closest('.modal-body');
		if (parent.length > 0)
			options.dropdownParent = parent;
		el.select2(options).on('change', self.handleChange);
		//}
	}

	componentDidUpdate(prevProps) {
		if (JSON.stringify(prevProps.options) !== JSON.stringify(this.props.options) || prevProps.placeholder != this.props.placeholder || prevProps.required != this.props.required) {
			this.componentDidMount();
		}
		if (JSON.stringify(prevProps.value) != JSON.stringify(this.props.value)) {
			this.refSelect.current.value = this.props.value;
			this.handleChange();
			$(this.refSelect.current).val(this.props.value).trigger('change');
		}
	}

	componentWillUnmount() {
		if (this.props.multiple) {
			let el = $(this.refSelect.current);
			setTimeout(() => {
				el.select2('destroy');
			}, 1);
		}
		this.context && this.context.removeInput(this.props.name);
	}

	render() {
		const select = (<select value={this.state.value} required={this.props.required} onChange={this.handleChange} className="form-select mb-1" disabled={this.props.readOnly || (this.context && this.context.readOnly)} ref={this.refSelect} multiple={this.props.multiple} id={this.htmlId}>
			{/*{!this.props.multiple ? <option value="">{t.commonSelect}</option> : null}*/}
			{!this.props.required || (this.props.value == '' || this.props.value == null) ? <option value="">{t.commonSelect}</option> : null}
			{Array.isArray(this.props.optgroups) ?
				this.props.optgroups.map((og, i) => <optgroup key={i} label={og[0]}>{og[1].map((o, j) => <option key={j} value={o[0]}>{o[1]}</option>)}</optgroup>)
				: Array.isArray(this.props.options) ?
					this.props.options.map((item, i) =>
						<option key={i} value={item[0]}>{T(item[1] || '[???]')}</option>)
					: Object.keys(this.props.options).map((key, i) =>
						<option key={i} value={key}>{T((this.props.property ? this.props.options[key][this.props.property] : this.props.options[key]) || '[???]')}</option>)}
		</select>);
		if (!this.props.label)
			return (
				<div id={this.props.id} className="mb-1">
					{select}
				</div>
			);
		return (
			<div id={this.props.id} className="form-floating mb-1">
				{select}
				{this.state.error && <output>{this.state.error}</output>}
				<label htmlFor={this.htmlId}>{T(this.props.label)}</label>
			</div>
		);
	}
}